<template>
    <div class="text-muted">
        <b-row>
            <b-col>
                <div class="ml-2">
                    <h4>{{ $t('careerObjective.plans') }}</h4>
                </div>
            </b-col>
            <b-col>
                <div class="pr-2">
                    <b-button
                        size="sm"
                        variant="primary"
                        class="float-right"
                        v-if="canCreate"
                        @click="
                            () => $router.push('/v2/career-objectives/plan/new')
                        "
                    >
                        {{
                            $t('form.button.new') +
                                ' ' +
                                $t('careerObjective.plan')
                        }}
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="p-2">
                    <div v-if="!careerObjective.length">
                        <b-alert show>
                            {{ $t('careerObjective.empty') }}
                        </b-alert>
                    </div>
                    <div v-else>
                        <div
                            :key="careerObjective.id"
                            v-for="careerObjective in careerObjectives"
                        >
                            <b-card>
                                <div v-if="canEdit(careerObjective)">
                                    <b-dropdown
                                        id="dropdown-dropright"
                                        class="float-right m-2"
                                        variant="link"
                                        size="sm"
                                        dropleft
                                        :no-caret="true"
                                    >
                                        <template slot="button-content">
                                            <i
                                                class="fa fa-ellipsis-v fa-lg"
                                            ></i>
                                        </template>
                                        <b-dropdown-item
                                            @click="
                                                $router.push(
                                                    `/v2/career-objectives/plan/edit/${careerObjective.id}`
                                                )
                                            "
                                        >
                                            {{ $t('form.button.edit') }}
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            @click="
                                                deleteCareerObjective(
                                                    careerObjective.id
                                                )
                                            "
                                        >
                                            {{ $t('form.button.delete') }}
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <h4>{{ careerObjective.title }}</h4>
                                <div>
                                    <span class="mb-2 mr-4">
                                        <span class="font-weight-bold mr-1"
                                            >{{ $t('targets.period') }}:</span
                                        >
                                        <b-badge variant="primary">
                                            {{
                                                $t(
                                                    `careerObjective.period.${careerObjective.period}`
                                                )
                                            }}
                                        </b-badge>
                                    </span>
                                    <span>
                                        <span class="font-weight-bold mr-1">
                                            {{ $t('form.label.planType') }}:
                                        </span>
                                        <b-badge variant="primary">
                                            {{
                                                $t(
                                                    `careerObjective.type.${careerObjective.type}`
                                                )
                                            }}
                                        </b-badge>
                                    </span>
                                    <p>
                                        <span class="font-weight-bold mr-1">
                                            {{
                                                $t(
                                                    'careerObjective.interestedAreas'
                                                )
                                            }}:
                                        </span>
                                        <b-badge
                                            class="mr-2"
                                            variant="secondary"
                                            :key="interestedArea.id"
                                            v-for="interestedArea in careerObjective.interested_areas"
                                        >
                                            {{ interestedArea.area.name }}
                                        </b-badge>
                                    </p>
                                </div>
                                <div>
                                    <p class="font-weight-bold mb-0">
                                        {{ $t('form.label.description') + ':' }}
                                    </p>
                                    <p
                                        v-html="
                                            careerObjective.description
                                                ? careerObjective.description
                                                : '-'
                                        "
                                    />
                                </div>
                                <div>
                                    <div>
                                        <span class="font-weight-bold">
                                            {{
                                                $t(
                                                    'form.label.availabilityForChanges'
                                                ) + ':'
                                            }}
                                        </span>
                                        <span>
                                            {{
                                                $t(
                                                    `form.switch.${
                                                        careerObjective.has_mobility
                                                            ? 'yes'
                                                            : 'no'
                                                    }`
                                                )
                                            }}
                                        </span>
                                    </div>
                                    <div>
                                        <p class="font-weight-bold mb-0">
                                            {{
                                                $t('careerObjective.mobility') +
                                                    ':'
                                            }}
                                        </p>
                                        <p
                                            v-html="
                                                careerObjective.mobility_description
                                                    ? careerObjective.mobility_description
                                                    : '-'
                                            "
                                        />
                                    </div>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import { deleteCareerObjective } from '../api'
import {
    operationSuccessfullySnotification,
    notificationError,
} from '../functions'

export default {
    name: 'careerObjective',
    props: {
        careerObjectives: {
            type: Array,
            required: true,
        },
        canCreate: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        deleteCareerObjective(id) {
            proceedWithConfirmation({
                onConfirm: () => deleteCareerObjective(id),
                callback: () => {
                    operationSuccessfullySnotification('delete')
                    this.$emit('updated')
                },
                onError: () => {
                    notificationError()
                },
            })
        },
        canEdit(careerObjective) {
            return (
                careerObjective.user_id == this.$store.state.currentUser.user.id
            )
        },
    },
}
</script>
